package com.milta.feature.legal.data.remote

import com.milta.core.network.ApiException
import com.milta.core.network.Endpoints
import com.milta.core.network.baseUrl
import com.milta.feature.auth.data.remote.dto.ApiError
import com.milta.feature.legal.data.remote.dto.LegalDocumentDto
import com.milta.feature.legal.domain.entity.LegalDocumentType
import com.milta.feature.legal.domain.entity.urlSlug
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.statement.HttpResponse
import io.ktor.http.isSuccess

/**
 * GET /api/v1/legal-documents/{type} — public endpoint, no auth required. Reuses the app's single
 * (authenticated) [HttpClient] like every other `*Api` — harmless here since the endpoint ignores
 * auth entirely, and keeps DI/Koin wiring identical to the rest of the codebase (see
 * [com.milta.di.networkModule]).
 */
class LegalDocumentApi(private val client: HttpClient) {

    suspend fun getLegalDocument(type: LegalDocumentType, lang: String): LegalDocumentDto =
        client.get("$baseUrl/${Endpoints.legalDocument(type.urlSlug)}") {
            parameter("lang", lang)
        }.decodeOrThrow()

    private suspend inline fun <reified T> HttpResponse.decodeOrThrow(): T {
        if (!status.isSuccess()) {
            val apiError = runCatching { body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${status.value}"
            throw ApiException(status.value, message)
        }
        return body()
    }
}
